'use client'

import { VideoPlayer } from '@/components/jbda/video-player'
import { getVideoUrl } from '@/config/site.config'
import { useEffect, useRef, useState } from 'react'

export function VideoFrame() {
  const [playing, setPlaying] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const io = new IntersectionObserver(
      ([entry]) => setPlaying(entry.isIntersecting),
      { threshold: 0.5 }
    )
    if (ref.current) io.observe(ref.current)
    return () => { if (ref.current) io.unobserve(ref.current) }
  }, [])

  return (
    <div className='relative aspect-square w-[80vw] max-w-md sm:w-full'>
      <div className='absolute left-[-20px] top-[20px] z-0 h-full w-full rounded-xl bg-primaryBright sm:left-[-30px] sm:top-[30px] md:left-[-40px] md:top-[40px]'/>
      <div ref={ref} className='relative z-10 h-full w-full rounded-xl bg-primaryBright shadow-lg'>
        <VideoPlayer videoUrl={getVideoUrl() as string} playing={playing}/>
      </div>
    </div>
  )
}
